import React from 'react'
import { useGlobalContext } from './context'
import uuid from 'react-uuid'

const AudioList = ({onChangeTrackClick, currentTrack}) => {

    const {audioList} = useGlobalContext();

    return (
        
        <React.Fragment>
            <div className="audio-list">
                <h2 className="audio-list-title text-center mb-4 pb-1">Lista de Audios</h2>
                <ul className="audio-list-items-container">
                    {audioList.map((track, index) => {
                        const {title, artist} = track;
                        //console.log(uuid());
                        return <li key={uuid()} className={`${currentTrack === index ? 'audio-list-item-active' : ''} audio-list-item` } onClick={() => onChangeTrackClick(index)}>{`${title} | ${artist}`}</li>
                    })}
                </ul>       
            </div>
            
        </React.Fragment>
    )
}

export default AudioList
